
import { useState } from 'react';
import Hero from './components/Hero';
import Concept from './components/Concept';
import Features from './components/Features';
import Salary from './components/Salary';
import Message from './components/Message';
import WorkConditions from './components/WorkConditions';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Navbar from './components/Navbar';

export default function Home() {
  const [showApplyModal, setShowApplyModal] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50/30 via-white to-pink-50/20">
      <Navbar onApplyClick={() => setShowApplyModal(true)} />
      <Hero onApplyClick={() => setShowApplyModal(true)} />
      <Concept />
      <Features />
      <Salary />
      <Message />
      <WorkConditions />
      <FAQ />
      <Contact onApplyClick={() => setShowApplyModal(true)} />

      {showApplyModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl p-8 max-w-md w-full relative">
            <button
              onClick={() => setShowApplyModal(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-pink-100 rounded-full mx-auto mb-4">
                <i className="ri-chat-smile-3-line text-3xl text-pink-500"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">LINEで簡単応募</h3>
              <p className="text-sm text-gray-600 mb-6">
                下記のボタンからLINE公式アカウントを友だち追加して、お気軽にお問い合わせください。
              </p>
              <a
                href="https://line.me/ti/p/SLGJSTrCeD"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#06C755] text-white px-8 py-3 rounded-full font-medium hover:bg-[#05b34c] transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-line-fill text-xl"></i>
                LINE公式アカウント
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
